import { createContext } from 'react'

export const RecycleBinContext = createContext(null)
